import React, { useState, useRef, useEffect } from "react";
import ProfilePic from '../../assets/iconos/perf360.svg'
import DropdownArrow from '../../assets/iconos/triangulo-blanco.svg'
import Settings from '../../assets/iconos/tuerca.png'
import usuario from '../../assets/iconos/usuario.png'
import historial from '../../assets/iconos/historial.png'
import cerrarsesion from '../../assets/iconos/cerrar_sesion.png'

import { logOut } from '../../Services/User.js';
import elementContains from "../../utils/moment/DOM/elementContains";



function DropDownUser(props) {
    const [open, setOpen] = useState(false);

    const el = {
        Menus: [{ key: 1, opt: 'Mi Perfil', dir: '/profile' }, { key: 2, opt: 'Ajustes', dir: '#' }, { key: 3, opt: 'Historial', dir: '#' }, { key: 4, opt: 'Cerrar Sesion', dir: '/' }],
        Iconos: [usuario, Settings, historial, cerrarsesion]
    }

    const menuRef = useRef();
    const imgRef = useRef();
    const divRef = useRef();

    useEffect(() => {
        function handle(e) {
            if (!elementContains(menuRef.current, e.target)
                && !elementContains(imgRef.current, e.target)
                && !elementContains(divRef.current, e.target)) {
                setOpen(false);
            }
        }

        window.addEventListener("click", handle);

        return () => window.removeEventListener("click", handle);
    }, [menuRef.current, imgRef.current, divRef.current])




    const handlerUsers = (e) => {
        e.preventDefault();
        props.setActualFrame('profile');
        setOpen(false);
    }

    const handlerLogOut = (e) => {
        e.preventDefault();
        logOut();
        setOpen(false);
    }


    return (
        <div>
            <div className='profileMenu' style={{ cursor: "pointer" }}  ref={divRef}
            >
                <div className='usermenu'>
                    <a to="/profile">
                        <div className='username' onClick={() => setOpen(!open)}>
                            <h5 className="userNameText">{props.usrData.name}</h5>
                            <img src={props.usrData?.profilePic || ProfilePic} alt="ProfilePic" className="profile-img" />
                        </div>
                    </a>
                </div>
                <img
                    onClick={() => setOpen(!open)}
                    ref={imgRef}
                    src={DropdownArrow}
                    alt="DropdownArrow"
                    className={open ? "icon-dropdown-active" : 'icon-dropdown setpointer'} />
            </div>
            {
                open && (
                    <div ref={menuRef}
                        className='dropdownUser'>
                        <ul>
                            <li className='dropdownUserButton setpointer' onClick={handlerUsers}>
                                <img src={usuario} className="noti-option-icon" />
                                <a>Usuario</a>
                            </li>
                            <li className='dropdownUserButton setpointer' onClick={handlerLogOut}>
                                <img src={cerrarsesion} className="noti-option-icon" />
                                <a>Cerrar sesion</a>
                            </li>
                        </ul>
                    </div>
                )}

        </div>
    );
}



export default DropDownUser